import axios from 'axios';
import { orderBy } from 'lodash';
import { getHaulingCompaniesQuery } from './queries';

const getHaulingCompanies = async () => {
    try {
        const fields = ['id', 'name'];
        const haulingCompaniesQuery = getHaulingCompaniesQuery({ fields, filterDeleted: true });
        const haulingCompaniesRequest = axios.get(haulingCompaniesQuery);

        const { data } = await haulingCompaniesRequest;
        return orderBy(data, ['name'], ['asc']);
    } catch (err) {
        // eslint-disable-next-line
        console.log(err);
        throw new Error('Unable to process request.');
    }
};

export default getHaulingCompanies;
